module.exports = __webpack_public_path__ + "media/images/google-play-badge-en-99bf4cef.png";